import { DataTableSettings } from '@mono/types/src/weather-widgets/datatable-settings';
import { LineGraphSettings } from '@mono/types/src/weather-widgets/linegraph-settings';

interface getUnitsDataTable {
    databilityIds: string[];
    settings: DataTableSettings;
    type: 'dataTable';
}
export const getUnitsDataTable = ({ databilityIds, settings }: getUnitsDataTable) => {
    return Object.fromEntries(
        databilityIds.map((d) => {
            const relevantHeading = settings.headings.find((h) => h.databilities.includes(d));
            if (!relevantHeading) return [d, null];

            const databilityIndex = relevantHeading.databilities.indexOf(d);
            if (databilityIndex === -1) return [d, null];

            return [d, relevantHeading.databilityUnits[databilityIndex]];
        })
    );
};

interface getUnitsLineGraph {
    databilityIds: string[];
    settings: LineGraphSettings;
    type: 'lineGraph';
}
export const getUnitsLineGraph = ({ databilityIds, settings }: getUnitsLineGraph) => {
    return Object.fromEntries(
        databilityIds.map((d) => {
            const item = settings.items.find((i) => i.databilityId === d);
            if (item) return [d, item.unit];
            return [d, null];
        })
    );
};

type getUnitsProps = getUnitsDataTable | getUnitsLineGraph;
export const getUnits = (props: getUnitsProps) => {
    if (props.type === 'dataTable') return getUnitsDataTable(props);
    if (props.type === 'lineGraph') return getUnitsLineGraph(props);
    return {};
};
